import axios from "axios";
import useAuth from "hooks/useAuth";

const useAPI = () => {
  const { getAccessToken, refreshAccessToken, GBWM_BASE_URL, cleanUp, BASE_URL } = useAuth();

  const auth_api = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
  });

  // Add an interceptor to attach the access token to requests
  auth_api.interceptors.request.use(
    async (config) => {
      config.headers["use-cookie-auth"] = "true"; // This header is used to indicate that the request should use cookie-based authentication
      config.headers["Content-Type"] = "application/json"; // Set the content type to JSON
      if (config.useAuth !== false) {
        const accessToken = getAccessToken();
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Add an interceptor to handle token expiration
  auth_api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const response_code = error.response?.data?.code || null;
      if (
        (error.response.status === 401 || response_code === "token_not_valid") &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        try {
          const newAccessToken = await refreshAccessToken();
          axios.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          cleanUp();
          return Promise.reject(refreshError);
        }
      }
      // After retry fails, log out if 401 occurs again
      if (error.response.status === 401 || response_code === "token_not_valid") {
        cleanUp();
      }

      return Promise.reject(error);
    }
  );

  const api = axios.create({
    baseURL: GBWM_BASE_URL,
    withCredentials: true,
  });

  // Add an interceptor to attach the access token to requests
  api.interceptors.request.use(
    async (config) => {
      config.headers["use-cookie-auth"] = "true"; // This header is used to indicate that the request should use cookie-based authentication
      config.headers["Content-Type"] = "application/json"; // Set the content type to JSON
      if (config.useAuth !== false) {
        const accessToken = getAccessToken();
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Add an interceptor to handle token expiration
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const newAccessToken = await refreshAccessToken();
          axios.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          cleanUp();
          return Promise.reject(refreshError);
        }
      }
      // After retry fails, log out if 401 occurs again
      if (error.response.status === 401) {
        cleanUp();
      }
      return Promise.reject(error);
    }
  );

  return { api, auth_api };
};

export default useAPI;
